import CASL from '@/utils/constants/casl'

export default {
  path: 'data-problem',
  children: [
    {
      path: '',
      name: 'data-problem.list',
      meta: {
        action: 'read',
        subject: CASL.ACCESS.DATA_PROBLEM
      },
      component: () => import('./list/DataProblemListPage.vue')
    }
  ]
}
